export default "__VITE_ASSET__DFbD7rwz__"